// src/components/workedExampleView.js
//
// Pure, framework-free view logic for the worked-example "attempt then reveal"
// card (WorkedExampleReveal.jsx): which parts render for a given prompt/model/
// revealed state. Retrieval-practice design: the PROMPT is always visible, the
// MODEL hides behind a one-tap confidence row until revealed. JSX-free so it
// unit-tests under `node --test`.

// One-tap confidence labels (any tap reveals; rating is ephemeral local state,
// never persisted).
export const CONFIDENCE_LEVELS = ['Not yet', 'Roughly', 'Confident'];

// What renders: prompt when present; the confidence/reveal row only while an
// existing model is still hidden; the model only once revealed. A model-less
// example never shows a reveal row (nothing to reveal); a prompt-less example
// still gets the row (the model alone is the retrieval target). String presence
// mirrors the sections' existing `e.prompt &&` truthiness. showCard guards the
// bordered wrapper: an example whose prompt AND model are unusable (malformed
// non-string data) renders nothing rather than an empty box.
export function exampleView({ prompt, model, revealed }) {
    const hasPrompt = typeof prompt === 'string' && prompt.length > 0;
    const hasModel = typeof model === 'string' && model.length > 0;
    return {
        showCard: hasPrompt || hasModel,
        showPrompt: hasPrompt,
        showConfidenceRow: hasModel && !revealed,
        showModel: hasModel && !!revealed,
    };
}
